import { render, staticRenderFns } from "./Cakes.vue?vue&type=template&id=8a2b956a&scoped=true"
import script from "./Cakes.vue?vue&type=script&lang=js"
export * from "./Cakes.vue?vue&type=script&lang=js"
import style0 from "./Cakes.vue?vue&type=style&index=0&id=8a2b956a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2b956a",
  null
  
)

export default component.exports